<template>
  <van-popup
    v-model="value"
    round
    :close-on-click-overlay="false"
    @click-overlay="onClickOverlay"
    position="bottom"
  >
    <van-picker
      :columns="columns"
      :value-key="valueKey ? valueKey : 'text'"
      show-toolbar
      :title="title"
      item-height="35px"
      @cancel="cancel"
      @confirm="confirm"
      :cancel-button-text="cancelReset ? '重置' : '取消'"
    />
  </van-popup>
</template>
<script>
export default {
  props: [
    "title", //标题
    "columns", //头部描述内容
    "valueKey", //选项对象中，文字对应的 key
    "onChange",
    "value",
    "cancelReset",//取消按钮重置
  ],
  data() {
    return {
    };
  },
  methods:{
    //点击遮罩层
    onClickOverlay(){
      this.$emit('input', false)
    },
    confirm(value, index){
      this.$emit('input', false)
      if(this.onChange) {
          this.onChange(value, index)
      }
    },
    cancel(){
      this.$emit('input', false)
      if(this.cancelReset) {
        if(this.onChange) {
          this.onChange(null, -1)
        }
      }
    },
  }
};
</script>

<style lang="less">
</style>
